import {Component, OnInit} from '@angular/core';
import {BmPaymentPlanMockService} from '../../mock/bm-payment-plan-mock.service';
import {BmPaymentPlanService} from '../../service/bm-payment-plan.service';

/**
 * Test component for BmPaymentPlan
 * Uses mock service to provide test data
 */
@Component({
  selector: 'bm-payment-plan-test',
  templateUrl: './bm-payment-plan-test.component.html',
  styleUrls: ['./bm-payment-plan-test.component.scss'],
  standalone: false,
  providers: [
    { provide: BmPaymentPlanService, useClass: BmPaymentPlanMockService },
    // {
    //   provide: BmPaymentPlanService,
    //   useFactory: createQlTestFactory(BmPaymentPlanMockService),
    //   deps: [[new SkipSelf(), new Optional(), BmPaymentPlanService]]
    // }
  ]
})
export class BmPaymentPlanTestComponent implements OnInit {

  selectedDunningId: number = 30004;
  availableDunningIds: number[] = [];

  constructor(private paymentPlanService: BmPaymentPlanService) {}

  ngOnInit(): void {
    // Get available mock IDs if using mock service
    if (this.paymentPlanService instanceof BmPaymentPlanMockService) {
      this.availableDunningIds = (this.paymentPlanService as BmPaymentPlanMockService).getAvailableMockDunningIds();
    }
  }

  onDunningIdChange(): void {
    // Component will reload with new dunning ID
  }
}
